import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Form, Modal, Row, Select, Upload, Button, Col } from 'antd'
import { SketchPicker } from 'react-color'
import { CameraOutlined, UploadOutlined } from '@ant-design/icons'

import { AButton } from 'src/components/atoms/Button'
import { FormItem } from 'src/components/molecules/FormItem'
import { connect } from 'react-redux'

import settingData from './settingData.json'

const _UpdateSettingQR = ({
  dispatch,
  reset,
  token,
  dataUpdate,
  loading,
  visible,
  onCancel,
  setUpdateItems
}) => {
  const [form] = Form.useForm()
  const [items, setItems] = useState({})
  const [logoFile, setLogoFile] = useState([])
  const [imageScanPage, setImageScanPage] = useState([])
  const [documentFile, setDocumentFile] = useState([])
  const [withText, setWithText] = useState()
  const [select, setSelect] = React.useState('DEFAULT')
  const [showCustomClaimButton, setShowCustomClaimButton] = useState('DEFAULT')
  const [buttonColor, setButtonColor] = useState('#4F55F2')
  const [showColorPicker, setShowColorPicker] = useState(false)
  const [showCustomSubmitButton, setShowCustomSubmitButton] = useState('DEFAULT')

  useEffect(() => {
    setItems(dataUpdate)

    setLogoFile(
      dataUpdate?.logo
        ? [{ name: dataUpdate.logo.split('/').pop(), url: dataUpdate.logo }]
        : []
    )

    setImageScanPage(
      dataUpdate?.imageScanPage
        ? [
            {
              name: dataUpdate.imageScanPage.split('/').pop(),
              url: dataUpdate.imageScanPage
            }
          ]
        : []
    )

    setDocumentFile(
      dataUpdate?.document
        ? [
            {
              name: dataUpdate.document.split('/').pop(),
              url: dataUpdate.document
            }
          ]
        : []
    )

    switch (dataUpdate?.urlScanPage) {
      case 'DEFAULT':
        setSelect(dataUpdate?.urlScanPage)
        break
      case 'IMAGE':
        setSelect('IMAGE')
        break
      default:
        setSelect('CUSTOM')
    }

    withCustomText(onHandleSizeValtoKey(dataUpdate?.size))

    setShowCustomClaimButton(
      !dataUpdate?.buttonClaim || (dataUpdate?.buttonClaim &&
        dataUpdate?.buttonClaim?.showCustomClaimButton === 'DEFAULT')
        ? 'DEFAULT'
        : 'CUSTOM'
    )
    setButtonColor(dataUpdate?.buttonClaim?.buttonColor || '#4F55F2')

    setShowCustomSubmitButton(
      !dataUpdate?.buttonSubmit || (dataUpdate?.buttonSubmit &&
        dataUpdate?.buttonSubmit?.showCustomSubmitButton === 'DEFAULT')
        ? 'DEFAULT'
        : 'CUSTOM'
    )

    if (dataUpdate?.buttonClaim) {
      setItems((prev) => ({
        ...prev,
        buttonText: dataUpdate.buttonClaim.buttonText,
        buttonColor: dataUpdate.buttonClaim.buttonColor,
        buttonHorizontalPosition:
          dataUpdate.buttonClaim.buttonHorizontalPosition,
        buttonVerticalPosition: dataUpdate.buttonClaim.buttonVerticalPosition
      }))
    }

    if (dataUpdate?.buttonSubmit) {
      setItems((prev) => ({
        ...prev,
        customSubmitText: dataUpdate.buttonSubmit.customSubmitText
      }))
    }
  }, [dataUpdate])

  const onHandleSizeValtoKey = (size) => {
    if (size !== 'A3 : QR Code SIze 20x20mm with Text') {
      if (size) {
        size = size.replace(/ /g, '_')
        size = size.toUpperCase()
        size = size.replace('_:', '')
        size = size.replace('1_QR_CODE_', '1_')
        size = size.replace('-_QR_CODE', 'QR')
        size = size.replace('MM', '')
        size = size.replace('WITH_', '')
        size = size.replace('SIZE_', '')
        size = size.replace('X', 'x')
        return size
      }
    } else {
      return 'MEDIUM'
    }
  }

  const withCustomText = (size) => {
    switch (size) {
      case 'A4_1_FOR_1_PAGE_QR_20x20_TEXT':
        return setWithText(true)
      case 'A4_1_FOR_1_PAGE_QR_40x40_TEXT':
        return setWithText(true)
      case 'A0_10x10_TEXT':
        return setWithText(true)
      case 'A4_10x10_TEXT':
        return setWithText(true)
      case 'MEDIUM':
        return setWithText(true)
      default:
        return setWithText(true)
    }
  }

  const scanPageValues = {
    DEFAULT: 'Default',
    CUSTOM: 'Custom Page',
    IMAGE: 'Custom Image'
  }

  const handleColorChange = (color) => {
    setButtonColor(color.hex)
    setItems({ ...items, buttonColor: color.hex })
  }

  const buttonPositionOptions = [
    {
      value: 'left',
      label: 'Left'
    },
    {
      value: 'center',
      label: 'Center'
    },
    {
      value: 'right',
      label: 'Right'
    }
  ]

  const buttonVerticalPositionOptions = [
    {
      value: 'top',
      label: 'Top'
    },
    {
      value: 'bottom',
      label: 'Bottom'
    }
  ]

  const onHandleUpdate = () => {
    const data = {
      size: onHandleSizeValtoKey(items?.size),
      name: items?.name,
      urlScanPage: items?.urlScanPage,
      textInQrcode: items?.textInQrcode,
      logo: logoFile.length > 0 ? logoFile[0].originFileObj : null,
      imageScanPage:
        imageScanPage.length > 0 ? imageScanPage[0].originFileObj : null,
      document: documentFile.length > 0 ? documentFile[0].originFileObj : null,
      isImageScanPageRemoved: !!(
        items?.imageScanPage && imageScanPage.length === 0
      ),
      isDocumentRemoved: !!(items?.document && documentFile.length === 0),
      selectScanPage: select,
      showCustomClaimButton: showCustomClaimButton,
      buttonText: items?.buttonText,
      buttonColor: items?.buttonColor,
      buttonHorizontalPosition: items?.buttonHorizontalPosition,
      buttonVerticalPosition: items?.buttonVerticalPosition,
      showCustomSubmitButton: showCustomSubmitButton,
      customSubmitText: items?.customSubmitText
    }

    dispatch({
      type: 'setting_qr/update_setting_qr',
      payload: {
        token,
        settingQrcodeId: dataUpdate.id,
        data: data
      }
    })

    setTimeout(() => setUpdateItems({ visible: false, data: {} }), 1000)
  }

  const onHandleLogoFile = ({ fileList }) => {
    setLogoFile(
      fileList.length
        ? [
            {
              name: fileList[0].name,
              url: URL.createObjectURL(fileList[0].originFileObj),
              originFileObj: fileList[0].originFileObj
            }
          ]
        : []
    )
  }

  const onHandleImageScanPage = ({ fileList }) => {
    setImageScanPage(
      fileList.length
        ? [
            {
              name: fileList[0].name,
              url: URL.createObjectURL(fileList[0].originFileObj),
              originFileObj: fileList[0].originFileObj
            }
          ]
        : []
    )
  }

  const onHandleDocumentFile = ({ fileList }) => {
    setDocumentFile(
      fileList.length
        ? [
            {
              name: fileList[0].name,
              url: URL.createObjectURL(fileList[0].originFileObj),
              originFileObj: fileList[0].originFileObj
            }
          ]
        : []
    )
  }

  return (
    <Modal
      title='Update Setting QR '
      visible={visible}
      footer={false}
      onCancel={onCancel}
      wrapClassName='modal-setting-qr'
    >
      <Form layout='vertical' form={form}>
        <Form.Item name='logo' label='Logo'>
          <Upload
            beforeUpload={() => false}
            onChange={onHandleLogoFile}
            onRemove={() => setLogoFile([])}
            listType='picture-card'
            fileList={logoFile}
            maxCount={1}
            accept='image/*'
          >
            <CameraOutlined />
          </Upload>
        </Form.Item>
        <FormItem
          value={items?.name}
          label='Name'
          onChange={({ target }) => setItems({ ...items, name: target.value })}
          placeholder='Setting name'
        />
        <FormItem
          label='QR Size'
          value={items?.size}
          placeholder='Choose qr size'
          select
          onChange={(value) => setItems({ ...items, size: value })}
        >
          {settingData.map((setting) => (
            <Select.Option key={setting.size}>{setting.label}</Select.Option>
          ))}
        </FormItem>
        <FormItem
          label='Scan Page'
          placeholder='Choose scan page'
          select
          onChange={(value) => setSelect(value)}
          value={scanPageValues[select]}
        >
          {Object.entries(scanPageValues).map(([key, label]) => (
            <Select.Option key={key} value={key}>
              {label}
            </Select.Option>
          ))}
        </FormItem>
        {select === 'CUSTOM' && (
          <FormItem
            value={items?.urlScanPage}
            label='Custom URL Page'
            placeholder='eg: https://example.com/product'
            onChange={({ target }) => {
              setItems({ ...items, urlScanPage: target.value })
            }}
          />
        )}
        {select === 'IMAGE' && (
          <Form.Item name='imageScanPage' label='Custom Image Scan Page'>
            <Upload
              beforeUpload={() => false}
              onChange={onHandleImageScanPage}
              onRemove={() => setImageScanPage([])}
              listType='picture-card'
              fileList={imageScanPage}
              maxCount={1}
              accept='image/*'
            >
              <CameraOutlined />
            </Upload>
          </Form.Item>
        )}
        {withText && (
          <FormItem
            textarea
            value={items?.textInQrcode}
            label='Custom Text Scan QR Code'
            placeholder='eg: Scan this QR code to view product details'
            onChange={({ target }) =>
              setItems({ ...items, textInQrcode: target.value })}
          />
        )}
        <Form.Item
          label='Auto-Downloading Document'
          name='autoDownloadingDocument'
        >
          <Upload
            maxCount={1}
            accept='.pdf'
            onChange={onHandleDocumentFile}
            beforeUpload={() => false}
            onRemove={() => setDocumentFile([])}
            fileList={documentFile}
          >
            <Button icon={<UploadOutlined />}>Click to Upload</Button>
          </Upload>
        </Form.Item>
        <FormItem
          label='Custom Button Claim Coupon'
          placeholder='Choose claim button option'
          select
          onChange={(value) => {
            setShowCustomClaimButton(value)
            if (value === 'CUSTOM' && !items?.buttonText) {
              setItems((prev) => ({
                ...prev,
                buttonText: 'CLAIM COUPON',
                buttonColor: buttonColor,
                buttonHorizontalPosition: 'right',
                buttonVerticalPosition: 'bottom'
              }))
            }
          }}
          value={showCustomClaimButton}
        >
          <Select.Option key='DEFAULT'>Default</Select.Option>
          <Select.Option key='CUSTOM'>Custom</Select.Option>
        </FormItem>
        {showCustomClaimButton !== 'DEFAULT' && (
          <>
            <Row gutter={16}>
              <FormItem
                col={16}
                label='Button Text'
                value={items?.buttonText}
                placeholder='Custom text for the claim button'
                onChange={({ target }) =>
                  setItems({ ...items, buttonText: target.value })}
              />
              <Col span={8}>
                <Form.Item label='Button Color'>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div
                      style={{
                        padding: '5px',
                        background: '#fff',
                        borderRadius: '1px',
                        boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
                        display: 'inline-block',
                        cursor: 'pointer'
                      }}
                      onClick={() => setShowColorPicker(!showColorPicker)}
                    >
                      <div
                        style={{
                          width: '36px',
                          height: '14px',
                          borderRadius: '2px',
                          background: items?.buttonColor || buttonColor
                        }}
                      />
                    </div>
                    <span style={{ marginLeft: '10px', fontSize: '14px' }}>
                      {items?.buttonColor || buttonColor}
                    </span>
                    {showColorPicker && (
                      <div style={{ position: 'absolute', zIndex: 2 }}>
                        <div
                          style={{
                            position: 'fixed',
                            top: '0px',
                            right: '0px',
                            bottom: '0px',
                            left: '0px'
                          }}
                          onClick={() => setShowColorPicker(false)}
                        />
                        <div style={{ position: 'relative' }}>
                          <a
                            href='#'
                            onClick={() => setShowColorPicker(false)}
                            style={{
                              backgroundColor: '#FF0000',
                              position: 'absolute',
                              top: '-15px',
                              right: '-15px',
                              border: 'none',
                              borderRadius: '100%',
                              fontSize: '16px',
                              cursor: 'pointer',
                              zIndex: 3,
                              color: '#fff',
                              fontWeight: 'bold',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              padding: '0 7px 0 7px'
                            }}
                          >
                            ×
                          </a>
                          <SketchPicker
                            color={items?.buttonColor || buttonColor}
                            onChange={handleColorChange}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <FormItem
                col={12}
                label='Horizontal Position'
                placeholder='Select position'
                select
                value={items?.buttonHorizontalPosition || 'right'}
                onChange={(value) =>
                  setItems({ ...items, buttonHorizontalPosition: value })}
              >
                {buttonPositionOptions.map((item, index) => (
                  <Select.Option key={index} value={item.value}>
                    {item.label}
                  </Select.Option>
                ))}
              </FormItem>
              <FormItem
                col={12}
                label='Vertical Position'
                placeholder='Select position'
                select
                value={items?.buttonVerticalPosition || 'bottom'}
                onChange={(value) =>
                  setItems({ ...items, buttonVerticalPosition: value })}
              >
                {buttonVerticalPositionOptions.map((item, index) => (
                  <Select.Option key={index} value={item.value}>
                    {item.label}
                  </Select.Option>
                ))}
              </FormItem>
            </Row>
          </>
        )}
        <FormItem
          label='Custom Submit Claim Coupon'
          placeholder='Choose submit button option'
          select
          onChange={(value) => {
            setShowCustomSubmitButton(value)
            if (value === 'CUSTOM' && !items?.customSubmitText) {
              setItems((prev) => ({
                ...prev,
                customSubmitText: 'Submit'
              }))
            }
          }}
          value={showCustomSubmitButton}
        >
          <Select.Option key='DEFAULT'>Default</Select.Option>
          <Select.Option key='CUSTOM'>Custom</Select.Option>
        </FormItem>
        {showCustomSubmitButton !== 'DEFAULT' && (
          <FormItem
            label='Submit Button Text'
            value={items?.customSubmitText}
            placeholder='Submit'
            onChange={({ target }) =>
              setItems({ ...items, customSubmitText: target.value })}
          />
        )}
        <Row justify='end'>
          <AButton
            onClick={onHandleUpdate}
            loading={loading}
            icon={<UploadOutlined />}
            type='primary'
            title='Submit'
          />
        </Row>
      </Form>
    </Modal>
  )
}

const mapStateToProps = ({ reducerSettingQR }) => {
  return { ...reducerSettingQR }
}

export const UpdateSettingQR = connect(mapStateToProps)(_UpdateSettingQR)

_UpdateSettingQR.propTypes = {
  visible: PropTypes.bool,
  onCancel: PropTypes.func,
  reset: PropTypes.bool,
  token: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  loading: PropTypes.bool,
  dispatch: PropTypes.func,
  dataUpdate: PropTypes.object,
  setUpdateItems: PropTypes.func
}
